// extracted by mini-css-extract-plugin
export default {"cardContainer":"PackageRed_cardContainer__xCI63","info":"PackageRed_info__RAz+P","text":"PackageRed_text__77dpf","childCard":"PackageRed_childCard__dkljj"};